import { BreadcrumbItem } from '@/types/services';

export const CONTENTSET_TITLE = 'スクーミーIDEの使い方';
export const BASE_URL = '/hello-schoomy/ide-guide/s1';

export type PaddingSize = {
    base: number;
    md: number;
    lg: number;
};

export type TutorialItem = {
    code?: number;
    codeBackgroundColor?: string;
    title?: string;
    titleColor?: string;
    description?: string;
    descriptionColor?: string;
    topic?: string;
    topicBackgroundColor?: string;
    topicTextColor?: string;
    image?: ImageItem;
    borderColor?: string;
    button?: ButtonItem;
    bottomPadding?: PaddingSize;
};

export type ImageSize = {
    base: number;
    md: number;
    lg: number;
};

export type ImageItem = {
    imageName: string;
    widths?: ImageSize;
};

export type ButtonItem = {
    title: string;
    titleColor?: string;
    backgroundColor?: string;
    url: string;
};

export type GuideDataItem = {
    contentsUuid: string;
    level: string;
    title: string;
    subTitle: string;
    titleColor: string;
    backgroundColor: string;
    tutorials: TutorialItem[];
};

export const IDE_GUIDE_DATA: readonly GuideDataItem[] = [
    {
        contentsUuid: '8f2d3c9e',
        level: '01',
        title: 'スクーミーIDEについて',
        subTitle: 'スクーミーIDEとスクーミーIDE-PROをダウンロードします',
        titleColor: '#ffffff',
        backgroundColor: '#439fa2',
        tutorials: [
            {
                image: {
                    imageName: 'ce1c667a.png',
                },
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                topic: 'スクーミーIDEとは',
                topicBackgroundColor: '#fcb900',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#fcb900',
                title: '測って、比べる。すぐに試すことができます。',
                titleColor: '#439fa2',
                description:
                    'スクーミーボードに書き込むプログラムをつくる場所のことです。スクーミーブロックエディタでブロックを組み立てて、アップロードをおすことで、IDE上で言語が生成されます。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                topic: 'スクーミーブロックエディタとは',
                topicBackgroundColor: '#fcb900',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#fcb900',

                description: `ブロックを組み立てて直感的にプログラミングをすることができます。

                    つくったプログラムを保存して開くこともできますし、ウェブページからダウンロードしたプログラム（sbpファイル）をここで開くこともできます。シリアルモニタ・グラフモニタを利用することで、センサーコネクターの値をすぐにデータとして見ることができます。`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                button: {
                    title: 'インストーラーページはこちら',
                    url: '/installer/ide',
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                codeBackgroundColor: '#fcb900',
                title: '■ ダウンロード後の流れ',
                titleColor: '#eb5852',
                description:
                    '上記のインストールボタンからダウンロードをすると、以下の流れでスクーミーIDEが使用できます',
                descriptionColor: '#000',
                bottomPadding: { base: 20, md: 20, lg: 20 },
            },

            {
                image: {
                    imageName: '95fac078.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                image: {
                    imageName: 'b87b6bbe.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                image: {
                    imageName: '889e5adf.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 80, md: 80, lg: 80 },
            },

            {
                description: 'Windowsの場合は、デスクトップ画面に以下２つのアイコンができていれば完了です。',
                descriptionColor: '#000',
                image: {
                    imageName: '5eda4aed.png',
                    widths: { base: 280, md: 225, lg: 250 },
                },

                bottomPadding: { base: 80, md: 80, lg: 80 },
            },

            {
                description: `※ブルーボードを利用したプログラミングには、スクーミーIDE-PROが必要になります。
                　こちらはスクーミーAPIライセンスを購入している学校のみインストール可能なものです。`,
                descriptionColor: '#000',
                bottomPadding: { base: 120, md: 120, lg: 120 },
            },

            {
                topic: 'スクーミーIDE-PROとは',
                topicBackgroundColor: '#eb5852',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#eb5852',
                title: 'データを集めに行く。そして、そのデータをみんなで共有することができる。',
                titleColor: '#eb5852',
                description:
                    'スクーミーボードに書き込むプログラムをつくる場所のことです。スクーミーブロックエディタでブロックを組み立てて、アップロードをおすことで、IDE上で言語が生成されます。',
                descriptionColor: '#000',

                image: {
                    imageName: 'c241c26f.png',
                },
                borderColor: '#fcb900',

                bottomPadding: { base: 80, md: 80, lg: 80 },
            },

            {
                topic: 'スクーミーAPIとは',
                topicBackgroundColor: '#c052ebff',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#c052ebff',
                titleColor: '#c052ebff',
                description:
                    'スクーミーAPIを利用することで、社会で活用されている様々なアプリケーションと繋げることができます。具体的には、自分の手元にあるセンサーのデータなどを、インターネットを活用し社会で活用されているサービスとつなげることができます。例えば、LINEと繋げることでデータの通知を送ることができますし、Googleのサービスであるスプレッドシートと繋げることで、データを記録することもできます。API（Application Programming Interface） とは、アプリケーション（プログラム）からサーバーやサービスにアクセスして、データの取得や操作をするための仕組みです。このドキュメントで説明しているAPIは、「スクーミーのサーバーが提供するサービスをブルーボードやプログラムから利用するための窓口」です。スクーミーのAPIは、ブルーボードから以下のサービスを利用するために提供されています。・天気情報の取得・スプレッドシートの読み書き・通知メッセージの送信（Slack / LINE）・Web画面の表示（ON/OFFスイッチ /センサー表示）・タイマーの計算※スクーミーAPIを使用する場合、使用料をいただいております。この使用料はAPIの利用の他に以下の用途にも使われています。・デバイス識別チェックブルーボードの利用者が登録されているユーザーであるかをチェックしています。・ログの監視APIに関するエラーの原因特定や不正使用を防ぐために、ログの監視を行っています。ログの監視は有料のクラウド上で行っています。・ネットワーク管理ネットワークの保守・運用全般を行っています。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                description:
                    'スクーミーのAPIは、以下の流れで利用します。①スクーミーブロックエディタでプログラムを作成「天気ブロック」「スプレッドシート書込みブロック」などのブロックを組み合わせてプログラムを作成します。②ブルーボードにプログラムを書き込み 作成したプログラムをブルーボードに書き込みます。③ブルーボードからAPIを呼び出しブルーボードがネットワークを介してスクーミーのAPIサーバーにリクエストを送り、結果を受け取ります。',
                descriptionColor: '#fcb900',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                image: {
                    imageName: '29ecc6bc.png',
                },
            },
        ],
    },
    {
        contentsUuid: '22cae935',
        level: '02',
        title: 'スクーミーIDE Windows版のダウンロードについて',
        subTitle: 'スクーミーIDE Windows版のダウンロードについて説明します',
        titleColor: '#ffffff',
        backgroundColor: '#439fa2',
        tutorials: [
            {
                title: 'このページは、スクーミーボードを持っていて、プログラミングをはじめる時に見るページです。スマートフォンやタブレットでこのページを見ながらパソコンで操作を行ってください。利用するパソコンがWindowsであることを確認してください。',
                titleColor: '#439fa2',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                title: 'このページではスクーミーIDE windows版のインストールに関して説明します。スクーミーIDE PRO版や他のOSのアプリは別ページをご確認ください。',
                titleColor: '#439fa2',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                topic: 'プログラミングを始めるには、以下のものを準備していただく必要があります',
                topicBackgroundColor: '#fcb900',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#fcb900',

                description: `インターネット接続が可能なWindowsパソコン・スクーミーボード`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                code: 1,
                codeBackgroundColor: '#fcb900',
                title: 'こちらをクリックしてインストーラーをダウンロードしてください',
                titleColor: '#439fa2',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                button: {
                    title: 'インストーラーページはこちら',
                    url: '/installer/ide',
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 2,
                codeBackgroundColor: '#fcb900',
                title: 'ダウンロードしたインストーラーをクリックしてください',
                titleColor: '#439fa2',
                image: {
                    imageName: '09facc3b.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },

                description: `デスクトップに配置するとこのようなアイコンです。これがインストーラーになります。こちらをクリックしてください。デスクトップにない場合は、ダウンロードフォルダにあります。スクーミーボードのイラストのものをクリックしてください。`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 3,
                codeBackgroundColor: '#fcb900',
                title: 'スクーミーIDEとSchooMyWorkspaceがダウンロードできているか確認してください',
                titleColor: '#439fa2',
                image: {
                    imageName: 'bb937663.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },

                description: `この2つがデスクトップにあることを確認してください。上のアイコンを、スクーミーIDEと呼び、下のアイコンを、スクーミーワークスペースと呼んでいます。`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 4,
                codeBackgroundColor: '#fcb900',
                title: 'これでインストールが完了です',
                titleColor: '#439fa2',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
        ],
    },

    {
        contentsUuid: '8df8d396',
        level: '03',
        title: 'スクーミーIDE Mac版のダウンロードについて',
        subTitle: 'スクーミーIDE Mac版のダウンロードについて説明します',
        titleColor: '#ffffff',
        backgroundColor: '#439fa2',
        tutorials: [
            {
                title: 'このページは、スクーミーボードを持っていて、プログラミングをはじめる時に見るページです。スマートフォンやタブレットでこのページを見ながらパソコンで操作を行ってください。利用するパソコンがMacであることを確認してください。',
                titleColor: '#439fa2',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                title: 'こちらのページは、スクーミーIDE mac版のインストールに関してです。スクーミーIDE PRO版や他のOSのアプリは別サイトをご確認ください。',
                titleColor: '#439fa2',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                topic: 'プログラミングを始めるには、以下のものを準備していただく必要があります',
                topicBackgroundColor: '#fcb900',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#fcb900',

                description: `インターネット接続が可能なMacパソコン・スクーミーボード`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                code: 1,
                codeBackgroundColor: '#fcb900',
                title: 'こちらをクリックしてインストーラーをダウンロードしてください',
                titleColor: '#439fa2',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                button: {
                    title: 'インストーラーページはこちら',
                    url: '/installer/ide',
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 2,
                codeBackgroundColor: '#fcb900',
                title: 'ダウンロードしたインストーラーを「controlキー + クリック」で「開く」をクリックしてください',
                titleColor: '#439fa2',
                image: {
                    imageName: 'cd459b3f.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: 'f1430737.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: 'f902f599.png',
                    widths: { base: 280, md: 560, lg: 400 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                description: `「開く」を選択してください`,
                descriptionColor: '#000',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                description: `macOS Sequoia 15.0以降の場合は以下の画面が表示されるためこちらをご確認ください`,
                descriptionColor: '#000',

                image: {
                    imageName: 'f95d0184.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 3,
                codeBackgroundColor: '#fcb900',
                title: 'インストーラーが立ち上がったら以下の手順でインストールを進めてください',
                titleColor: '#439fa2',
                image: {
                    imageName: '99d6c91e.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `「続ける」をクリック`,
                descriptionColor: '#000',

                image: {
                    imageName: '5ff8c7e5.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `「インストール」をクリック`,
                descriptionColor: '#000',

                image: {
                    imageName: '4cf9fad0.png',
                    widths: { base: 280, md: 560, lg: 340 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `ユーザーのPCログインパスワードを入力して「ソフトウェアをインストール」をクリック`,
                descriptionColor: '#000',

                image: {
                    imageName: 'd376965c.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `インストールが開始されます`,
                descriptionColor: '#000',

                image: {
                    imageName: '07422174.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `「閉じる」をクリック`,
                descriptionColor: '#000',

                image: {
                    imageName: 'b59fb8e8.png',
                    widths: { base: 280, md: 560, lg: 400 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `「ゴミ箱に入れる」をクリックして、インストールは完了です`,
                descriptionColor: '#000',

                bottomPadding: { base: 120, md: 120, lg: 120 },
            },

            {
                code: 4,
                codeBackgroundColor: '#fcb900',
                title: 'スクーミーIDEとSchooMyWorkspaceがダウンロードできているか確認してください',
                titleColor: '#439fa2',
                image: {
                    imageName: '11b0271b.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },

                description: `この２つがデスクトップにあることを確認してください。上のアイコンを、スクーミーワークスペースと呼び、下のアイコンを、スクーミーIDEと呼んでいます。`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 5,
                codeBackgroundColor: '#fcb900',
                title: '【M1チップ搭載Macのみ】アプリ立ち上げの際に「Rosettaをインストールする必要があります」という案内が表示されたらインストールを選択してください',
                titleColor: '#439fa2',
                image: {
                    imageName: 'e13cb19c.png',
                    widths: { base: 280, md: 560, lg: 400 },
                },

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 6,
                codeBackgroundColor: '#fcb900',
                title: 'これでインストールが完了です',
                titleColor: '#439fa2',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 7,
                codeBackgroundColor: '#fcb900',
                title: 'インストールが始まらない場合はこちらを確認してください',
                titleColor: '#439fa2',
                image: {
                    imageName: 'f95d0184.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                description: `「完了」を選択してください`,
                descriptionColor: '#000',
                image: {
                    imageName: '87d1a093.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `画面左上のアップルマーク押した後「システム設定…」を選択してください`,
                descriptionColor: '#000',
                image: {
                    imageName: '77f0b26c.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `「プライバシーとセキュリティ」を選択してください`,
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `右側の項目を下の方まで見ていくと「お使いのMacを保護するために”SchooMyIDE～」が表示されます。文字の横の「このまま開く」を選択してください`,
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                code: 8,
                codeBackgroundColor: '#fcb900',
                title: 'これでインストールが完了です',
                titleColor: '#439fa2',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
        ],
    },
    {
        contentsUuid: 'c94fd663',
        level: '04',
        title: 'スクーミーIDE Chromebook版のダウンロードについて',
        subTitle: 'スクーミーIDE Chromebook版のダウンロードについて説明します',
        titleColor: '#ffffff',
        backgroundColor: '#439fa2',
        tutorials: [
            {
                title: 'このページは、スクーミーボードを持っていて、プログラミングをはじめる時に見るページです。スマートフォンやタブレットでこのページを見ながらパソコンで操作を行ってください。利用するパソコンがChromebookであることを確認してください。',
                titleColor: '#439fa2',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                title: 'こちらのページは、スクーミーIDE Chromebook版のインストールに関してです。スクーミーIDE PRO版や他のOSのアプリは別サイトをご確認ください。',
                titleColor: '#439fa2',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                topic: 'プログラミングを始めるには、以下のものを準備していただく必要があります',
                topicBackgroundColor: '#fcb900',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#fcb900',

                description: `インターネット接続が可能なChromebookパソコン・Linux環境（ダウンロードが必要です）・スクーミーボード`,
                descriptionColor: '#000',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                topic: 'Linux環境',
                topicBackgroundColor: '#439fa2',
                topicTextColor: '#ffffff',

                description: `※2回ほどのクリックでダウンロードすることができるので操作は簡単ですが、それぞれ２つをダウンロードすることと環境設定（自動更新）を行うのに合計30分ほどかかります。`,
                descriptionColor: '#000',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                description: `※インストールをする際は、インターネット環境が必要です。`,
                descriptionColor: '#000',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                description: `途中、アイコンがずっとリロード状態になりますが、ここで環境設定をしていますので、PCを閉じたりしないでください。`,
                descriptionColor: '#000',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                description: `1.Chromebook で右下の時刻を選択します。`,
                descriptionColor: '#000',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                description: `2.設定  次に [詳細設定] 次に [デベロッパー] を選択します。`,
                descriptionColor: '#000',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                description: `3.[Linux 開発環境] の横の [オンにする] を選択します。`,
                descriptionColor: '#000',

                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                description: `※上記2、3に関してのイメージはこちら(PCの種類によって画面が異なる場合があります)。`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 1,
                codeBackgroundColor: '#fcb900',
                title: 'Linux環境のダウンロード方法について',
                titleColor: '#439fa2',

                image: {
                    imageName: 'bfad94f9.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: '13ef38b0.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 2,
                codeBackgroundColor: '#fcb900',
                title: '画面にしたがって「次へ」を押してください',
                titleColor: '#439fa2',
                image: {
                    imageName: '30c189be.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `Chrome OSの更新が求められた場合は、設定を開くを押してください。`,
                descriptionColor: '#000',
                image: {
                    imageName: '06015548.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `再起動を押してください。`,
                descriptionColor: '#000',
                image: {
                    imageName: 'c71efabf.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                description: `再起動後、もう一度STEP1の手順でLinux開発環境の設定画面を開きます。`,
                descriptionColor: '#000',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                description: `ユーザーネームに関しては何でも大丈夫です。特に変更がなければそのまま設定されたものにしておきます。ディスクサイズは、推奨（10.0GB）のまま、右下のインストールを押してください。`,
                descriptionColor: '#000',

                image: {
                    imageName: '30aaf928.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `このような画面でおよそ10分ほど待ちます`,
                descriptionColor: '#000',

                image: {
                    imageName: '53dc8263.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 3,
                codeBackgroundColor: '#fcb900',
                title: '完了したらこのような画面がPCに表示されます。',
                titleColor: '#439fa2',
                image: {
                    imageName: 'aa9d658d.png',
                    widths: { base: 280, md: 560, lg: 600 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 4,
                codeBackgroundColor: '#fcb900',
                description: '※スクーミーIDE PRO版のインストール用コマンドは別サイトをご確認ください。',
                title: 'こちらをクリックしてコマンドをコピーし、ここに貼り付けてください。',
                titleColor: '#439fa2',
                descriptionColor: '#000',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                button: {
                    title: 'インストーラーコマンドはこちら',
                    url: '/installer/ide',
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `インストールが終わったら再起動メッセージがでるので、PCを再起動して完成です。`,
                descriptionColor: '#000',
                image: {
                    imageName: '928bbdf5.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 120, md: 120, lg: 120 },
            },

            {
                topic: 'スクーミーIDEを立ち上げる方法',
                topicBackgroundColor: '#fcb900',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#fcb900',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                code: 1,
                codeBackgroundColor: '#fcb900',
                title: '左下のマルのようなアイコンからChromebookのメニューを開きます。',
                titleColor: '#439fa2',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                description: `その中の右下の「Linux アプリ」をクリックすると、「SchooMy IDE」があります。`,
                descriptionColor: '#000',

                image: {
                    imageName: '106874a0.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `クリックすると、このような画面が表示されます。`,
                descriptionColor: '#000',

                image: {
                    imageName: 'f0f68f8a.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `この画面から、少し待つと文字を入力できるような画面も表示されます。`,
                descriptionColor: '#000',

                image: {
                    imageName: '64b5a97e.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `このように、文字が打てそうな画面が表示できたら、設定は完了です。この画面をスクーミーIDEといい、ここでプログラミングをします。`,
                descriptionColor: '#000',

                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 2,
                codeBackgroundColor: '#fcb900',
                title: '接続テストをします',
                titleColor: '#439fa2',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                description: `再起動したら、この画面をもう一度開いてください。`,
                descriptionColor: '#000',

                image: {
                    imageName: '64b5a97e.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `ここでスクーミーボードに書き込み機をさして、パソコンに接続してください。（写真を参考にしてください）`,
                descriptionColor: '#000',

                image: {
                    imageName: '2db3818a.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `そうすると、PCに表示されるメッセージが出てきますので、『LINUXに接続する』を選んでください。`,
                descriptionColor: '#000',

                image: {
                    imageName: '920205e1.png',
                    widths: { base: 280, md: 560, lg: 400 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `画面のツールからシリアルポートに文字が表示されていることを確認してください。確認することができたら、SchooMyBlockEditorをおしてください。このSchooMyBlockEditorは、スクーミーブロックエディターとよび、プログラミングをサポートするアプリです。`,
                descriptionColor: '#000',

                image: {
                    imageName: '915bd429.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `このような画面が表示されたら準備完了です。`,
                descriptionColor: '#000',

                image: {
                    imageName: 'ea417b85.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `この画面の上にあるメニューで、アップロードをおしてください。このような画面が表示されます。`,
                descriptionColor: '#000',

                image: {
                    imageName: '53e4ebee.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                description: `『ボードへの書き込みが完了しました』と表示されたらテスト完了です。`,
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                code: 3,
                codeBackgroundColor: '#fcb900',
                title: 'これでインストールが完了です',
                titleColor: '#439fa2',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
        ],
    },
];

export const BREADCRUMB_IDE_GUIDE_ITEMS: Record<string, BreadcrumbItem[]> = {
    [BASE_URL]: [{ label: `${CONTENTSET_TITLE} 目次` }],
    ...Object.fromEntries(
        IDE_GUIDE_DATA.map((item) => [
            `${BASE_URL}/${item.contentsUuid}`,
            [{ label: CONTENTSET_TITLE, href: BASE_URL }, { label: item.title }],
        ]),
    ),
};
